import { useEffect, useRef, useState } from 'react'
import { vnumngr } from '../content.js'
import Icon from '../components/Icon.jsx'
import Screenshot from '../components/Screenshot.jsx'

export default function VnuMngr() {
  const [active, setActive] = useState(0)
  const tabs = useRef(null)
  const n = vnumngr.features.length
  const f = vnumngr.features[active]
  const go = (d) => setActive((i) => (i + d + n) % n)
  // Touch swipe on the screenshot, same rule as Slideshow: mostly-horizontal drags of 40px+.
  const swipe = useRef(null)
  const onPointerDown = (e) => { if (e.pointerType !== 'mouse') swipe.current = { x: e.clientX, y: e.clientY } }
  const onPointerUp = (e) => {
    const start = swipe.current
    swipe.current = null
    if (!start) return
    const dx = e.clientX - start.x
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(e.clientY - start.y)) go(dx < 0 ? 1 : -1)
  }

  // Keep the selected tab visible in the scrolling row; scrolls only the row, never the page.
  useEffect(() => {
    const row = tabs.current, tab = row?.children[active]
    if (row && tab && row.scrollWidth > row.clientWidth) row.scrollTo({ left: tab.offsetLeft - (row.clientWidth - tab.offsetWidth) / 2, behavior: 'smooth' })
  }, [active])
  return (
    <section className="section alt" id="vnumngr">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">{vnumngr.eyebrow}</span>
          <h2 className="display-sm">{vnumngr.title}</h2>
          <p>{vnumngr.subtitle}</p>
        </div>
        <h3 className="tabs-title">{vnumngr.featuresTitle}</h3>
        <div className="tabs" role="tablist" ref={tabs}>
          {vnumngr.features.map((x, i) => (
            <button key={x.shot} role="tab" aria-selected={i === active} className={i === active ? 'on' : ''} onClick={() => setActive(i)}>
              {x.label}
            </button>
          ))}
        </div>
        <div className="feature">
          <div className="feature-text">
            <h3>{f.title}</h3>
            <p>{f.text}</p>
            <ul className="checks">
              {f.bullets.map((b) => <li key={b}><Icon name="check" size={18} />{b}</li>)}
            </ul>
          </div>
          <div className="feature-shot" onPointerDown={onPointerDown} onPointerUp={onPointerUp} onPointerCancel={() => { swipe.current = null }}>
            {f.shots ? (
              <div className="newsletters">
                {f.shots.map((n) => <img key={n} src={`${import.meta.env.BASE_URL}screenshots/${n}.webp`} alt={`${n.replace('newsletter-', '')} newsletter made with VnuMngr`} loading="lazy" />)}
              </div>
            ) : <Screenshot key={f.shot} name={f.shot} label={`VnuMngr ${f.label} screen`} />}
          </div>
          {/* Arrows under the screenshot only show on small screens, where the tabs become one scrolling row. */}
          <div className="slide-nav tabs-nav">
            <button className="slide-btn" onClick={() => go(-1)} aria-label="Previous feature"><Icon name="arrow" size={18} /></button>
            <button className="slide-btn" onClick={() => go(1)} aria-label="Next feature"><Icon name="arrow" size={18} /></button>
          </div>
        </div>
      </div>
    </section>
  )
}
